"use server";
import axios from "axios";

interface IGroupslist {
  facultyId: number;
  educationForm: 1 | 2;
}
interface IGroupSchedule {
  groupId: number;
  weekType: "firstWeek" | "secondWeek" | "thirdWeek" | "fourthWeek";
}

export async function getGroupslist({ facultyId, educationForm }: IGroupslist) {
  try {
    const response = await axios.get(
      `http://schedule.mslu.by/backend/buttonClicked?facultyId=${facultyId}&educationForm=${educationForm}`
    );
    console.log(response.data);
    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export async function getGroupSchedule({ groupId, weekType }: IGroupSchedule) {
  const endpoint = `http://schedule.mslu.by/backend/?groupId=${groupId}&weekType=${weekType}`;
  let response;
  try {
    response = await axios.get(endpoint);
    const responseData = response.data.data;
    console.log(responseData);
    return response.data.data;
  } catch (e) {
    console.log(e);
  }
}
